import { createReducer, on } from '@ngrx/store';
import { lifeCycleActions } from '../life-cycle/life-cycle.actions';
import { activeClientActions } from './active-client.actions';
import { ActiveClientState, initialActiveClientState } from './active-client.state';

export const activeClientReducer = createReducer(
  initialActiveClientState,

  on(lifeCycleActions.resetState, () => initialActiveClientState),

  on(activeClientActions.setActiveClient, (state: ActiveClientState, { clientCode }) => ({
    ...state,
    clientCode,
  })),
);
